var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildrenBoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 71,
    viewBox: "0 0 53 71",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8042 11.9456L49.8043 11.9457C50.7318 12.8732 50.7318 14.3768 49.8043 15.3043L51.2185 16.7185L49.8043 15.3043L36.867 28.2416L36.2812 28.8274V29.6558V66.125C36.2812 67.4367 35.2179 68.5 33.9062 68.5H31.7187C30.4071 68.5 29.3437 67.4367 29.3437 66.125V50.8125V48.8125H27.3437H25.1562H23.1562V50.8125V66.125C23.1562 67.4367 22.0929 68.5 20.7812 68.5H18.5937C17.2821 68.5 16.2187 67.4367 16.2187 66.125V29.6558V28.8274L15.6329 28.2416L2.69564 15.3045C2.69564 15.3045 2.69564 15.3045 2.69564 15.3045C1.76812 14.3769 1.76812 12.8732 2.69564 11.9457L2.6957 11.9456C3.62308 11.0182 5.12685 11.0182 6.05423 11.9456L6.05429 11.9457L17.8978 23.7892L18.4836 24.375H19.312H33.1878H34.0162L34.602 23.7892L46.4456 11.9457L46.4457 11.9456C47.3731 11.0182 48.8769 11.0182 49.8042 11.9456ZM18.4062 10.3438C18.4062 6.0117 21.9179 2.5 26.25 2.5C30.582 2.5 34.0937 6.0117 34.0937 10.3438C34.0937 14.6757 30.582 18.1875 26.25 18.1875C21.9179 18.1875 18.4062 14.6757 18.4062 10.3438Z",
    stroke: "#0079FF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildrenBoy);
export default __webpack_public_path__ + "static/media/children_boy.bd08b36fd4f032b6f0810e2a18115574.svg";
export { ForwardRef as ReactComponent };